import _axios from 'axios'

const axios = _axios

export default axios.create({
  baseURL: process.env.API_URL,
  timeout: 10000,
  headers: {
    get: {
      'Accept': 'application/json'
    },
    post: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    put: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    delete: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
})



// WEBPACK FOOTER //
// ./src/repositories/repository.js